import { ref } from '@vue/composition-api';

export default function (props, { root }) {
   const _valid = ref(false);
   const store = root.$store;

   const valid = (value = null) => {
      if (value !== null) {
         _valid.value = value;
      }

      return _valid.value;
   }

   const next = () => {
      if (valid()) {
         store.dispatch('userJourney/nextStep');
      }
   };

   const previous = () => {
      store.dispatch('userJourney/previousStep');
   };

   return {
      valid,
      next,
      previous
   };
}

